<template>
	<div class="file-container">
		<a
			:class="{ reportFile: isReportFile }"
			target="_blank"
			class="fileName"
			href="#"
			@click.prevent="handleFileClick"
		>

      <span>
        <svg width="13.75" height="15" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;"><defs></defs><rect x="0" y="0" width="13.75" height="15" fill="transparent" class="stencil__selection-helper"></rect><path d="M13.75 12.302061576860293C13.75 13.069410005180824 13.493333333333332 13.709681623715792 12.979999999999999 14.222876432465196 12.466666666666663 14.736071241214592 11.823777777777776 14.995112430392865 11.051333333333332 15 10.166444444444442 15 9.396444444444443 14.67253283632181 8.741333333333333 14.017598508965431 8.741333333333333 14.017598508965431 1.1146666666666667 6.400321276242176 1.1146666666666667 6.400321276242176 0.3715555555555555 5.647635556743054 0 4.760541673047661 0 3.7390396251559954 0 2.697987298835781 0.36177777777777775 1.8133371999439558 1.0853333333333333 1.0850893284805196 1.8088888888888888 0.3568414570170835 2.6888888888888887-0.004838693911065839 3.725333333333333 0.000048875696071259966 4.761777777777777 0.000048875696071259966 5.6564444444444435 0.36906038103492667 6.409333333333332 1.1070833917126368 6.409333333333332 1.1070833917126368 12.349333333333332 7.0601431732056925 12.349333333333332 7.0601431732056925 12.412888888888888 7.123681578098473 12.444666666666665 7.194551337401962 12.444666666666665 7.272752451116157 12.444666666666665 7.3802789824731745 12.344444444444443 7.531793640294427 12.143999999999998 7.727296424579914 11.943555555555553 7.9227992088654 11.791999999999998 8.02299438581171 11.689333333333332 8.027881955418849 11.606222222222222 8.027881955418849 11.530444444444443 7.996112752972457 11.461999999999998 7.932574348079673 11.461999999999998 7.932574348079673 5.514666666666666 1.9721832121759135 5.514666666666666 1.9721832121759135 4.996444444444443 1.4687635426407866 4.402444444444443 1.2170537078732226 3.7326666666666664 1.217053707873223 3.0384444444444445 1.2170537078732226 2.454222222222222 1.4614321882300807 1.98 1.950189148943796 1.5057777777777774 2.438946109657511 1.266222222222222 3.032785816924676 1.2613333333333332 3.7317082707452895 1.2613333333333332 4.4159680157444905 1.5106666666666666 5.007363938208085 2.009333333333333 5.505896038136076 2.009333333333333 5.505896038136076 9.628666666666666 13.137835979680744 9.628666666666666 13.137835979680744 10.039333333333332 13.548391826680266 10.513555555555554 13.753669750180027 11.051333333333332 13.753669750180027 11.471777777777776 13.753669750180027 11.818888888888885 13.616817801180186 12.092666666666664 13.343113903180505 12.366444444444442 13.06941000518082 12.50333333333333 12.722392563074084 12.503333333333334 12.302061576860293 12.503333333333334 11.764428920075204 12.297999999999998 11.290334668182897 11.887333333333332 10.879778821183379 11.887333333333332 10.879778821183379 6.1819999999999995 5.1759850896543185 6.1819999999999995 5.1759850896543185 6.010888888888887 5.014695292618792 5.812888888888888 4.934050394101029 5.587999999999999 4.934050394101029 5.402222222222221 4.934050394101029 5.245777777777777 4.997588798993812 5.118666666666666 5.124665608779378 4.991555555555555 5.251742418564945 4.9304444444444435 5.4081446459933336 4.9353333333333325 5.593872291064546 4.9353333333333325 5.804037784171443 5.015999999999999 5.99709678365336 5.1773333333333325 6.173049289510298 5.1773333333333325 6.173049289510298 9.203333333333331 10.197962860987744 9.203333333333331 10.197962860987744 9.271777777777775 10.266388835487664 9.305999999999997 10.339702379594723 9.306 10.417903493308916 9.305999999999997 10.520542455058795 9.203333333333331 10.674500897683618 8.998 10.879778821183379 8.792666666666666 11.085056744683136 8.638666666666666 11.185251921629447 8.535999999999998 11.180364352022313 8.457777777777777 11.180364352022313 8.386888888888887 11.148595149575922 8.323333333333332 11.08505674468314 8.323333333333332 11.08505674468314 4.297333333333333 7.0601431732056925 4.297333333333333 7.0601431732056925 3.8817777777777773 6.659362465420444 3.6739999999999995 6.170605504706729 3.6739999999999995 5.593872291064546 3.6739999999999995 5.056239634279458 3.862222222222222 4.601695660815703 4.238666666666666 4.230240370673279 4.61511111111111 3.858785080530855 5.0697777777777775 3.6730574354596426 5.602666666666666 3.6730574354596435 6.179555555555555 3.6730574354596426 6.665999999999999 3.8783353589594034 7.0619999999999985 4.288891205958925 7.0619999999999985 4.288891205958925 12.767333333333333 9.992684937487986 12.767333333333333 9.992684937487986 13.422444444444443 10.632956556022954 13.75 11.402748769147056 13.75 12.302061576860293 13.75 12.302061576860293 13.75 12.302061576860293 13.75 12.302061576860293" stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(255, 255, 255)" fill-rule="evenOdd"></path></svg>
      </span>
			<p v-if="isReportFile">{{ $t('reportFile') }}</p>
			<p v-else>{{ getFileName(url) }}</p>

			<feather-icon
				v-if="orderId !== -1 && !isReportFile && ['admin', 'manager'].indexOf(userRole) !== -1"
				icon="XIcon"
				class="fileName__close text-danger ml-2 cursor-pointer"
				@click.prevent
				@click.stop="confirmFileDeletion(url, file.s3_id)"
			/>
		</a>

		<div v-if="createdAt" class="createdAt">
			uploaded at: {{ createdAt }}
		</div>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "FileNameView",
	mixins: [databaseManager, notifier],
	props: {
		orderId: { default: -1, type: Number },
		file: { default: () => ({}), type: Object },
		url: { default: "", type: String },
		isReportFile: { default: false, type: Boolean },
		createdAt: { default: "", type: String }
	},
	computed: {
		userRole() {
			return this.$store.state.auth.role;
		}
	},
	methods: {
		getFileName(url) {
			if (!url) return "";
			const path = url.split("/");
			return path[path.length - 1];
		},

		async handleFileClick() {
			try {
				if (this.file.s3_id) {
					const response = await this.$http.post(`/${this.userRole}/order/download-url`, {
						s3_id: this.file.s3_id
					});

					const downloadUrl = response.data.data.downloadUrl;

					if (!downloadUrl) {
						this.notifyError(this.$t("fileDownloadError"));
						return;
					}

					window.open(downloadUrl, "_blank");
					return;
				}

				if (this.url) {
					window.open(this.url, "_blank");
				}
			} catch (e) {
				this.notifyError(this.$t("fileDownloadError"));
			}
		},

		confirmFileDeletion(fileUrl, s3_id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("confirmDeletion"),
				text: this.$t("doYouWantToDeleteFile"),
				accept: () => this.deleteUploadedPhoto(fileUrl, s3_id),
				acceptText: this.$t("confirm"),
				cancelText: this.$t("cancel")
			});
		},

		async deleteUploadedPhoto(url, s3_id) {
			try {
				const start = url.indexOf("/upload");
				const filePath = url.substr(start);

				await this.dbDeleteOne(this.orderId, filePath, s3_id);
				await this.$emit("fileDeleted");

				this.notifySuccess(this.$t("fileDeletedSuccessfully"));
			} catch {
				this.notifyError(this.$t("fileDeletionError"));
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.file-container {
	padding-right: 0;
	width: 100%;
	max-width: fit-content;

.fileName {
	padding-right: 0.5rem;
	width: 100%;
	max-width: fit-content;

	&.reportFile {
		background: transparent;
	}

	// max-width: 300px;
	// width: 100%;

	p {
		width: 100%;
		text-overflow: ellipsis;
		word-break: break-all;
		overflow: hidden;
		white-space: nowrap;
		// max-width: 400px;

		// &:hover {
		// 	white-space: normal;
		// 	max-width: 100%;
		// }
	}

	&__close {
		background: none;
	}
}

	.createdAt {
		font-size: 0.8rem;
		font-family: "Montserrat", Helvetica, Arial, sans-serif;
		color: gray;
		margin-left: 0.5rem;
	}
}

@media screen and (max-width: 768px) {
	.fileName {
		max-width: 280px;
		width: 100%;
	}
}
</style>
